const US_MARKET = 'US';
const TARIFF_COPY_MARKERS = ['International customers only:', 'Please note:'];

function updateTariffConsentCopy() {
  const country = window.Shopify?.country || document.documentElement.dataset.country || '';
  const consentLabel = document.querySelector('label[for="TariffConsent"]');

  if (!consentLabel) return;

  for (const element of consentLabel.querySelectorAll('div div')) {
    const text = element.textContent?.trim() || '';
    const isTariffCopy = TARIFF_COPY_MARKERS.some((marker) => text.startsWith(marker));

    if (isTariffCopy) {
      element.classList.toggle('dd-market-consent-copy--hidden', country !== US_MARKET);
    }
  }
}

const cartConsentObserver = new MutationObserver(updateTariffConsentCopy);

function initialiseMarketCartConsent() {
  updateTariffConsentCopy();
  cartConsentObserver.observe(document.body, { childList: true, subtree: true });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initialiseMarketCartConsent, { once: true });
} else {
  initialiseMarketCartConsent();
}
